export const observeScrollerContent = (
	scroller: HTMLElement,
	onChange: () => void,
): (() => void) => {
	const resizeObserver = new ResizeObserver(onChange);
	const observeChildren = () => {
		for (const child of Array.from(scroller.children)) {
			resizeObserver.observe(child);
		}
	};
	const mutationObserver = new MutationObserver((records) => {
		if (records.some(({ target }) => target === scroller)) {
			observeChildren();
		}
		onChange();
	});

	resizeObserver.observe(scroller, { box: "border-box" });
	observeChildren();
	mutationObserver.observe(scroller, {
		childList: true,
		subtree: true,
		characterData: true,
	});

	return () => {
		resizeObserver.disconnect();
		mutationObserver.disconnect();
	};
};
